import { page } from '@/api/base/baseCostItem'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(page)
